import { render, staticRenderFns } from "./FollowerTag.vue?vue&type=template&id=6a28e7d8&scoped=true"
import script from "./FollowerTag.vue?vue&type=script&lang=js"
export * from "./FollowerTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28e7d8",
  null
  
)

export default component.exports